// extracted by mini-css-extract-plugin
export default {"service__link":"style_service__link__fnAeU","active":"style_active__Gnpd9","notactive":"style_notactive__U2Y9D"};